import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import StandardLayout from '../../templates/StandardLayout';
import Steps from './Steps';
import VideoAndProduct from './VideoAndProduct';
import ImageAndCopy from './ImageAndCopy';

const LooksArticleComponent = ({
  breadcrumb,
  isStepsPage,
  isVideoAndProductPage,
  isImageAndCopyPage,
}) => (
  <StandardLayout>
    <Breadcrumbs items={breadcrumb} />
    {isStepsPage && <Steps />}
    {isVideoAndProductPage && <VideoAndProduct />}
    {isImageAndCopyPage && <ImageAndCopy />}
  </StandardLayout>
);

LooksArticleComponent.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
  isStepsPage: PropTypes.bool,
  isVideoAndProductPage: PropTypes.bool,
  isImageAndCopyPage: PropTypes.bool,
};

export default connect(({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  isStepsPage: R.prop('isStepsPage', content),
  isVideoAndProductPage: R.prop('isVideoAndProductPage', content),
  isImageAndCopyPage: R.prop('isImageAndCopyPage', content),
}))(LooksArticleComponent);
